/* A "week" of warm, story-sparking prompts — one per day. */
export const PROMPTS = [
  {
    day: 'Day 1',
    q: "What's a smell or taste that takes you straight back to childhood?",
    help: 'Close your eyes for a second. Where are you? Who else is there?',
  },
  {
    day: 'Day 2',
    q: 'Tell the story of how you met someone you love.',
    help: 'The first moment, the first words — however small.',
  },
  {
    day: 'Day 3',
    q: "What's the bravest thing you've ever done?",
    help: "It doesn't have to look brave to anyone but you.",
  },
  {
    day: 'Day 4',
    q: "Describe an ordinary day from a time in your life you'd relive.",
    help: 'Morning to night. The boring, beautiful details.',
  },
  {
    day: 'Day 5',
    q: "What's a lesson someone taught you that you've never forgotten?",
    help: 'Who taught it to you — and did you understand it then?',
  },
  {
    day: 'Day 6',
    q: "What's a tradition in your family, and where did it come from?",
    help: 'Food, holidays, sayings, the little rituals nobody questions.',
  },
  {
    day: 'Day 7',
    q: 'What do you most want the people who come after you to know?',
    help: 'Say it to them directly, in your own voice.',
  },
];
